module.exports = __webpack_public_path__ + "family.png";